import { IconBuildingCommunity, IconHome } from "@tabler/icons-react";
import Text from "../../UI/Text";
// @ts-expect-error pure js
import Tabs from "../../UI/Tabs";
import Button from "../../UI/Button";
import ChoiceCard from "./ChoiceCard";
import styles from "./TypeLogement.module.css";

interface TypeLogementProps {
  setFieldValue: (field: string, value: unknown) => void;
}

export default function TypeLogement({ setFieldValue }: TypeLogementProps) {
  const { selectNextTab, selectPreviousTab } = Tabs.useActiveTab();

  function next(type: string) {
    setFieldValue("type_habitat", type);
    selectNextTab();
  }

  return (
    <div className={styles.step}>
      <Text>De quel type de logement s'agit-il ?</Text>
      <ChoiceCard
        icon={IconBuildingCommunity}
        title={"Un logement dans un immeuble"}
        subtitle={"Appartement, studio en copropriété"}
        onClick={() => next("collectif")}
      />
      <ChoiceCard
        icon={IconHome}
        title={"Un logement indépendant"}
        subtitle={"Maison individuelle, pavillon"}
        onClick={() => next("individuel")}
      />
      <div className={styles.footer}>
        <Button variant="secondary" onClick={() => selectPreviousTab()}>
          Précédent
        </Button>
      </div>
    </div>
  );
}
